import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ACCESS_TOKEN_NAME, Status } from "../../shared/constant";
import BgWrapper from "../../components/layout/BgWrapper";
import { login, resetSignupRequest } from "../../redux/actions/userActions";
import { RootState } from "../../redux/rootReducer";
import ROUTES from "../../routes";
import { isAccounts, isManager } from "../../utils/clapUtils";

// TODO Password
// password must contain at least 8 characters.
// password can’t be entirely numeric.

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginPending, userDetailsSuccess, userDetails } = useSelector(
    (state: RootState) => state.user,
  );
  const token = localStorage.getItem(ACCESS_TOKEN_NAME) || "";

  useEffect(() => {
    dispatch(resetSignupRequest());
  }, []);

  useEffect(() => {
    if (userDetailsSuccess && token) {
      // console.log("User Retrieve Fulfilled");
      if (userDetails.status === Status.INACTIVE) {
        navigate(ROUTES.PATHS.INACTIVE_ACCOUNT);
        return;
      }
      if (isManager(userDetails)) {
        navigate(ROUTES.PATHS.ADMIN.TRACKS);
        return;
      }
      if (isAccounts(userDetails)) {
        navigate(ROUTES.PATHS.ADMIN.INCOME);
        return;
      }
      navigate(ROUTES.PATHS.ADMIN.HOME);
    }
  }, [userDetailsSuccess]);

  const onFinish = (values: any) => {
    dispatch(login(values));
  };

  return (
    <BgWrapper>
      <Form
        name="normal_login"
        className="login-form w-[22.5rem]"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: "Please input your Username!" }]}
        >
          <Input
            prefix={<UserOutlined className="text-primary pr-1" />}
            placeholder="Username"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please input your Password!" }]}
        >
          <Input
            prefix={<LockOutlined className="text-primary pr-1" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Link
            to="/forgot-password"
            className="float-right text-primary hover:text-primary"
          >
            Forgot your password?
          </Link>
        </Form.Item>

        <Form.Item className="-mt-2">
          <Button
            type="primary"
            htmlType="submit"
            className="w-full"
            loading={loginPending as boolean}
          >
            Sign In
          </Button>
        </Form.Item>
        <div className="flex justify-between">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <div>Don't have an account yet?</div>
          <Link to="/signup" className="text-primary hover:text-primary">
            Sign Up
          </Link>
        </div>
      </Form>
    </BgWrapper>
  );
}

export default Login;

// .login-form {
//   max-width: 300px;
// }
